import { atom } from 'nanostores'

export const $isPlusPaywallOpen = atom<boolean>(false)

export const openPlusPaywall = () => {
  $isPlusPaywallOpen.set(true)
}

export const closePlusPaywall = () => {
  $isPlusPaywallOpen.set(false)
}
